import React, { useContext, useState } from "react";
import { ProductContext } from "../store";
import {
  Button,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Label,
  Spinner,
} from "reactstrap";
import Cookies from "js-cookie";
import { Navigate, NavLink as NavLinkRRD } from "react-router-dom";
import { NavLink } from "reactstrap";

const getWebsiteLabel = (website) => {
	if (!website) {
		return "";
	}
	return website.companyName?.trim() || website.websiteURL || "";
};

const Header = ({ hideWebsiteDropdown = false }) => {
  const [redirectLogout, setRedirectLogout] = useState(false),
    [dropdownToggle, setDropdownToggle] = useState(false),
    [websiteDropdown, setWebsiteDropdown] = useState(false),
    {
      userData,
      userLoader,
      currentWebsiteId,
      websiteLoader,
      websiteData,
      setCurrentWebsiteId,
      setUserWebsitePlan,
      setProductTypes,
    } = useContext(ProductContext);

  const logOut = () => {
    if (window.RvBotView) {
      window.RvBotView.destory();
    }
    Cookies.remove("_cb_admin_token");
    Cookies.remove("_website_id");
    setRedirectLogout(true);
  };

  const changeWebsite = (websiteId) => {
    const id = parseInt(websiteId, 10);
    Cookies.set("_website_id", String(id));
    setCurrentWebsiteId(id);
    setUserWebsitePlan(websiteData[id]?.websiteUserPlan || []);
    setProductTypes(websiteData[id]?.productsMapping || []);
  };

  if (redirectLogout) {
    return <Navigate to="/auth/login" replace />;
  }

  const currentWebsite = websiteData?.[currentWebsiteId];

  return (
    <div className="header-container">
      <header className="contentHeaderWrapper">
        <div className="contentHeaderInner">
          <div className="contentHeaderLeftWrap">
            {!hideWebsiteDropdown && (
              <Label className="storeNameLabel">
                <span className="storeNameLabelHeader">Website</span>
                {websiteLoader ? (
                  <Spinner size="sm" />
                ) : (
                  <Dropdown
                    direction="down"
                    toggle={() => setWebsiteDropdown((prevState) => !prevState)}
                    isOpen={websiteDropdown}
                  >
                    <DropdownToggle className="pr-0" nav>
                      <Button color="link" className="storeNameContentBtn">
                        <div className="storeNameContentWrap">
                          {getWebsiteLabel(currentWebsite)}
                        </div>
                        <span className="websiteSelectionArrow d-flex flex-column">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="11"
                            height="11"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="arrowUp"
                          >
                            <path d="m18 15-6-6-6 6"></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="11"
                            height="11"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="arrowDown"
                          >
                            <path d="m6 9 6 6 6-6"></path>
                          </svg>
                        </span>
                      </Button>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-arrow">
                      <div className="userDropDownMenu websiteDropdown">
                        {Object.keys(websiteData).map((websiteId) => (
                          <div
                            className="dropdownSubMenu"
                            key={websiteId}
                            onClick={() => changeWebsite(websiteId)}
                          >
                            <div className="d-flex align-item-center justify-content-between">
                              <div className="websiteDropdownLeft">
                                <p className="cbSubduedText textEllipsis mb-0">
                                  {getWebsiteLabel(websiteData[websiteId])}
                                </p>
                                {websiteData[websiteId]?.companyName?.trim() &&
                                  websiteData[websiteId]?.websiteURL ? (
                                    <p className="cbSubduedText textEllipsis mb-0 small">
                                      {websiteData[websiteId].websiteURL}
                                    </p>
                                  ) : null}
                              </div>
                              <div className="websiteDropdownRight">
                                <p className="cbSubduedText">
                                  {parseInt(currentWebsiteId, 10) === parseInt(websiteId, 10)
                                    ? "Current"
                                    : ""}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </DropdownMenu>
                  </Dropdown>
                )}
              </Label>
            )}
          </div>
          <div className="contentHeaderRightWrap">
            {userLoader ? (
              <Spinner />
            ) : (
              <Dropdown
                direction="down"
                toggle={() => setDropdownToggle((prevState) => !prevState)}
                isOpen={dropdownToggle}
              >
                <DropdownToggle className="pr-0" nav>
                  <div className="user userFlex">
                    <div
                      className={`avatar uiUserPicture avatarPrimary${
                        ((userData.userId || userData.adminId || 1) - 1) % 10
                      }`}
                    >
                      {(userData.firstName || "").substr(0, 1)}
                      {userData.lastName && userData.lastName.substr(0, 1)}
                    </div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="m6 9 6 6 6-6"></path>
                    </svg>
                  </div>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-arrow">
                  <div className="userDropDownMenu">
                    <div className="dropdownSubMenu">
                      <div className="dropdownMenuItemUser">
                        <div
                          className={`avatar uiUserPicture avatarPrimary${
                            ((userData.userId || userData.adminId || 1) - 1) % 10
                          }`}
                        >
                          {(userData.firstName || "").substr(0, 1)}
                          {userData.lastName && userData.lastName.substr(0, 1)}
                        </div>
                        <div className="user">
                          <div className="name">
                            {userData.firstName}{" "}
                            {userData.lastName && userData.lastName}
                          </div>
                          <div className="user-login">{userData.email}</div>
                        </div>
                      </div>
                    </div>
                    <div className="dropdownSubMenu">
                      <NavLink
                        to="/search/settings"
                        onClick={() => setDropdownToggle(false)}
                        tag={NavLinkRRD}
                      >
                        <span className="dropdownMenuItemUser">
                          <i className="fa-solid fa-sliders"></i>
                          <div className="name">Account Settings</div>
                        </span>
                      </NavLink>
                    </div>
                    <div className="dropdownSubMenu">
                      <span
                        className="dropdownMenuItemUser logout"
                        onClick={() => logOut()}
                      >
                        <div className="name">Logout</div>
                        <i className="fa-solid fa-arrow-right-from-bracket"></i>
                      </span>
                    </div>
                  </div>
                </DropdownMenu>
              </Dropdown>
            )}
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
